import { gql } from "graphql-tag";

export const PROPERTY = gql`
  query getPropertyUseCases($id: ID!) {
    property(id: $id) {
      id
      name
      propertyUseCases {
        id
        useCaseId
        propertyId
        messageId
        smsPrefix
        applicationId
        applicationIdFriendlyName
        messageIdFriendlyName
        active
        useCase {
          friendlyName
        }
      }
    }

    getUseCases {
      id
      name
      friendlyName
      description
    }

    getActiveSubaccounts {
      name
      id
    }
  }
`;

export const UPDATE_PROP_USE_CASES = gql`
mutation upsertPropertyUseCase($data: PropertyUseCaseInput!) {
  upsertPropertyUseCase(data: $data) {
    id
    useCaseId
    propertyId
    messageId
    smsPrefix
    applicationId
    useCase {
      id
      name
      friendlyName
      description
    }
  }
}
`;

export const GET_MESSAGE_GROUPS = gql`
query getMessageGroups($id: String) {
  getMessageGroups(id: $id) {
    id
    name
  }

  getSmsPhoneNumbers(id: $id) {
    id
    name
  }
}
`;
